import React from "react";

export default function CrownIcon({
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
  onClick,
  className,
  style = {},
  ...rest
}) {
  const mergedStyle = Object.assign(
    { width: size, height: size, cursor: onClick ? "pointer" : undefined },
    style
  );

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      onClick={onClick}
      className={className}
      style={mergedStyle}
      {...rest}
    >
      <path d="M4 20a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z" />
      <path d="m12.474 5.943 1.567 5.34a1 1 0 0 0 1.75.328l2.616-3.402" />
      <path d="m20 9-3 9" />
      <path d="m5.594 8.209 2.615 3.403a1 1 0 0 0 1.75-.329l1.567-5.34" />
      <path d="M7 18 4 9" />
      <circle cx="12" cy="4" r="2" />
      <circle cx="20" cy="7" r="2" />
      <circle cx="4" cy="7" r="2" />
    </svg>
  );
}
